import waFetch from './src/wa-fetch';
import responseTextAs from './src/response-text-as';
import errorAsObject from './src/error-as-object';
import errorAsObjectWithFallback from './src/error-as-object-with-fallback';
import apiRequest from './src/api-request';
import WaFetchError from './src/wa-fetch-error';

export { waFetch, responseTextAs, errorAsObject, errorAsObjectWithFallback, apiRequest, WaFetchError };
export const responseAsJson = responseTextAs(JSON.parse);
export const responseAsText = responseTextAs(String);
